var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ImportErrorAlert',{attrs:{"type":"warning","focus-on-mount":false,"title":_vm.$tc(`${_vm.I18N}.title`, _vm.rows.length),"lines":_vm.lines}},[_c('CopyToClipboardButton',{attrs:{"slot":"actions","text":_vm.tsv,"label":_vm.$t(`${_vm.I18N}.copy`)},slot:"actions"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }